import httpClient from "@/core/axios";

export default {
    namespaced: true,
    state: {
        page: {}
    },
    getters: {
        page(state) {
            return state.page;
        },
        components(state) {
            return state.page.components;
        }
    },
    actions: {
        async fetch(context, slug) {
            await context.commit("FLUSH_PAGE");
            return httpClient
                .get(`/api/guest/app/:app_uuid/pages/${slug}`)
                .then(data => context.commit("SET_PAGE", data));
        }
    },
    mutations: {
        FLUSH_PAGE(state) {
            state.page = {};
        },
        SET_PAGE(state, data) {
            state.page = data;
        }
    }
};
